import { render, staticRenderFns } from "./FormDropdown.vue?vue&type=template&id=b5527bb0&scoped=true"
import script from "./FormDropdown.vue?vue&type=script&lang=js"
export * from "./FormDropdown.vue?vue&type=script&lang=js"
import style0 from "./FormDropdown.vue?vue&type=style&index=0&id=b5527bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5527bb0",
  null
  
)

export default component.exports